export default __webpack_public_path__ + "static/media/money.1afc7eaa.png";